import React, { useCallback, useEffect, useState } from 'react';
import { Tooltip } from 'antd'
import 'antd/dist/antd.min.css'
import axios, { CancelTokenSource, CancelTokenStatic } from 'axios'
import message from '../Message';

type Detail = {
  ad?: boolean
  address?:string
  bedroom?:number
  distance?:number
  first_available?:string
  lat?:number
  link?:string
  lng?:number
  photo?:string
  price?:string
  source?:number
}

type DataT = {
  data?: any | Detail
  location?: string
  pClassName?: string
  isOwen?: boolean
  revisionDistance?: (address: string, distance: number, type: boolean) => void
}

type DisTanceParam = {
  search_str: string,
  lat: string
  lng: string
}

function ListUtil(props: DataT) {
  const {
    data = {},
    location,
    pClassName,
    isOwen
  } = props

  let [detail, setDetail] = useState(data)
  let [source, setSource] = useState<CancelTokenSource>()

  let timer:any = null

  let [loading, setLoading] = useState(false)

  const clearTimer = useCallback(() => {
    timer && window.clearTimeout(timer)
    timer = null
    if (source) {
      source.cancel('请求已取消：超时');
      // console.log('source.cancel')
    }
    setLoading(false)
  }, [setLoading, source])

  const setTimer = useCallback(() => {
    timer && clearTimer()
    setLoading(true)
    timer = window.setTimeout(() => {
      clearTimer()
    }, 6000)
  }, [clearTimer, setLoading])

  const getDistance = useCallback((param: DisTanceParam) => {
    if (timer) return
    const sourceToken = axios.CancelToken.source()
    setSource(sourceToken)
    const {
      search_str,
      lat,
      lng,
    } = param
    let url = `/chrome_extension/v1/get_distance?search_str=${search_str}&lat=${lat}&lng=${lng}`
    setTimer()
    axios({
      url,
      method: 'get',
      cancelToken: sourceToken.token
    })
      .then((res) => {
        if (res.data.data && res.data.data.length) {
          setDetail({
            ...detail,
            distance: res.data.data[0]
          })
        }
        setSource(undefined)
        clearTimer()
      })
      .catch(err => {
        clearTimer()
      })
  }, [clearTimer, detail, setTimer, timer])

  const openTab = useCallback(() => {
    if (loading) {
      return message('getting distance, please wait', 'warning')
    }
    const info = { 
      sign: 'detailClick',
      type: 'detailClick',
      data: {
        ...detail,
        location
      }
   }
    window.parent.postMessage(info, '*')
  }, [data, loading])

  useEffect(() => {
    if (location && data.lat && data.lng && !data.getNewDistance) {
      const param = {
        search_str: location,
        lat: data.lat,
        lng: data.lng
      }
      getDistance(param)
    }
    // 销毁时候取消请求
    return clearTimer()
  }, [])

  return (
    <div className={`${data.ad ? 'mb-[8px]' : 'mb-[8px]'} rounded-[8px] border-[2px] border-no-color hover:border-blue`}>
      <div
        onClick={openTab}
        className={`relative bg-white border border-lines hover:border-no-color
        rounded-[8px]  cursor-pointer ${pClassName}`}
      >
        <>
        {
          data.ad ?
            <>
              <div className=' relative flex justify-center items-center h-[26px] rounded-[8px] -top-[1px]' >
                <img
                  alt='empty'
                  className='w-[213px] h-[26px]'
                  src={require('../../../img/m2m_top@2.png')}
                />
                <span className=' absolute w-[122px] h-[26px] text-[12px] leading-[26px] font-[400] text-grey font-Poppins'>Month2Month Select</span>
              </div>
            </> : ''
        }
        </>
        
        {/* img */}
        <div className='px-[11px] mt-[18px] flex justify-between relative'>

          <div className=' h-[110px] w-[110px] flex-shrink-0'>
              {
                data.source === 0 ?
                <div className=' absolute left-[11px] -top-[6px] w-[102px] h-[18px] '>
                  <img
                    alt='empty'
                    className='w-[102px] h-[18px]'
                    src={require('../../../img/m2m_ex_t.png')}
                  />
                </div> : ''
              }
              <img alt='empty' src={data.photo || require('../../../img/s_template@3.png')} className='h-[110px] w-[110px] rounded-[6px]' />
          </div>

          <div className='font-Poppins ml-[12px] flex-1 overflow-hidden'>
              <div className='font-semibold text-lg text-black truncate' title={data.address}>{data.address}</div>
              {/* length */}
              <div
                className='text-[#000] mt-[8px] text-2xs line-clamp-3'
                title={`${data.distance} miles away from ${location}`}
              >
                  <i className='font-semibold not-italic'>{`${loading ? 'loading' : (detail.distance || data.distance)}`}</i><i className='not-italic font-light'> miles away from {location || '-'}</i>
              </div>
              {/* logo */}
              <div className='flex justify-between mt-[15px]'>
                  <div className='text-blue'>
                    {
                      data.price ?
                        <div className=' flex flex-wrap'>
                          <div className=' font-semibold text-3lg'>${data.price}{data.source === 0 ? '+' : ''}
                            <i className=' font-normal not-italic'>/</i>
                          </div>
                          <div className=' font-normal text-base'>30 Days</div>
                        </div>
                        :
                        <span className=' font-normal text-base'>Price Not Available</span>
                    }
                  </div>
                  <div className=' h-[24px] self-end flex-shrink-0'>
                      <img alt='empty' src={require(`../../../img/m2m_logo@3.png`)} className={`h-[24px] w-auto ${data.source === 0 ? '' : 'hidden'}`} />
                      <img alt='empty' src={require(`../../../img/zillow_logo@3.png`)} className={`h-[24px] w-auto ${data.source === 1 ? '' : 'hidden'}`} />
                      <img alt='empty' src={require(`../../../img/airbnb_logo@3.png`)} className={`h-[24px] w-auto ${data.source === 2 ? '' : 'hidden'}`} />
                      <img alt='empty' src={require(`../../../img/vrbo_logo@3.png`)} className={`h-[24px] w-auto ${data.source === 3 ? '' : 'hidden'}`} />
                  </div>
              </div>
          </div>
        </div>
        
        {/* title */}
        <div className='mt-[12px] flex justify-between items-center h-[32px] bg-light-blue px-[11px] font-Poppins rounded-b-lg'>
          
          <div className='font-normal text-ms text-grey'>
          <Tooltip title='First available date might not be accurate for this platform' placement='bottomLeft'>
            <span>First Available:&nbsp;&nbsp;</span>
          </Tooltip>
          <span>{data.first_available}</span>
          </div>
          <Tooltip title={`${data.bedroom ? `${data.bedroom} Bedrooms` : ''}`} placement='bottomRight'>
            <div className='font-semibold text-ms text-grey flex justify-between items-center hover:text-black cursor-pointer bg-left bg-no-repeat bg-[length:20px_20px] bg-[url(../img/bed_unactive.png)] hover:bg-[url(../img/bed_active.png)]'>
              <div className={`w-[20px] h-[20px]`} />
              <div className=' ml-[8px]'>{data.bedroom ? `${data.bedroom}` : ''}</div>
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default ListUtil;
